import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Popup} from 'semantic-ui-react';

import {usePanelComments} from '../../state/reports/usePanelComments';
import {usePanelContext} from './PanelContextProvider';

export const PanelViewComments = () => {
  const {panelRef} = usePanelContext();
  const {panelCommentCount, openPanelComments} = usePanelComments({
    panelRef,
  });

  if (panelCommentCount == null || panelCommentCount <= 0) {
    return null;
  }

  return (
    <Popup
      content="View comments"
      inverted
      size="mini"
      position="top center"
      trigger={
        <div className="panel-comments" onClick={openPanelComments}>
          <span>{panelCommentCount}</span>
        </div>
      }
    />
  );
};
